module.exports = __webpack_public_path__ + "lift.f25ac97d6f8aaf9f74c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/lift.png
// module id = 431
// module chunks = 1